var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-page-result"},[_c('header-component',{attrs:{"title":_vm.translate.headerTitleResult}}),_c('main',[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('message-result',{attrs:{"businessName":_vm.businessName,"type":_vm.type}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }